import Vue from 'vue';

const state = {
  tasks: [],
};

// mutations
const mutations = {
  setTasks(state, tasks) {
    Vue.set(state, 'tasks', tasks);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};